import {
    ISmakevailableVariant,
    IOneTimeTokenResponse,
    ISizeWithNavKeyPath,
    ISizeWithNavKeyPathResponse
} from './logoCreaterService.d';
import { IContext } from '../types';
import { request, logHttpError } from './../../helpers';

export class LogoCreaterService {
    private static _instance: LogoCreaterService;
    private context: IContext;
    private getAvailableSizeServicePath = 'api/logocreator/getAvailableSizeWithNavKeyPath';
    private getAvailableColorServicePath = 'api/logocreator/getAvailableColor';
    private getOneTimeTokenServicePath = 'api/logocreator/getott';
    private getLogoCreationStateForArticle = 'api/logocreator/getLogoCreationStateForArticleVariant';

    static get instance() {
        return this._instance || (this._instance = new this());
    }

    public constructor() {
        this.context = window.__PP_LC_CONTEXT__;
    }

    public getAvailableSizes(
        navigationKey: string,
        masterArticleNo: number,
        salesArticleNo: string,
        colorCode: number
    ): Promise<ISizeWithNavKeyPath | void> {
        const apiUrl = this.context.baseUrl
            + this.getAvailableSizeServicePath;
        const url = new URL(apiUrl);
        url.searchParams.append('salesArticleNo', salesArticleNo);
        url.searchParams.append('masterArticleNo', masterArticleNo.toString());
        url.searchParams.append('colorCode', colorCode.toString());
        if (navigationKey) {
            url.searchParams.append('navigationkey', navigationKey);
        }

        return request<ISizeWithNavKeyPathResponse>(url.toString())
            .then((responseData) => {
                if (!responseData)
                    throw new Error('fail to get size: empty response');

                const avaialbeSAVKeys: Array<ISmakevailableVariant> = [];
                responseData.size_types.map((sizeType) => {
                    sizeType.sizes.map((size) => {
                        if (size.salesArticleVariantKey?.length > 0)
                            avaialbeSAVKeys.push({
                                external_identifier: size.salesArticleVariantKey
                            });
                    });
                });

                return {
                    sizeTypes: avaialbeSAVKeys,
                    navKeyPath: responseData.nav_key_path,
                };
            })
            .catch(logHttpError);
    }

    public getOneTimeToken(): Promise<IOneTimeTokenResponse | void> {
        const apiUrl = this.context.baseUrl
            + this.getOneTimeTokenServicePath;
        const url = new URL(apiUrl);

        return request<IOneTimeTokenResponse>(url.toString())
            .then((ottResponse) => {
                if (!ottResponse)
                    throw new Error('fail to get one time token: empty response');

                // TODO: check time expire
                return ottResponse;
            })
            .catch(logHttpError);
    }

    public getAvailableColors(
        masterArticleNo: number,
        salesArticleNo: string,
        colorCode: number,
        navigationKey?: string
    ): Promise<Array<ISmakevailableVariant> | void> {
        const apiUrl = this.context.baseUrl
            + this.getAvailableColorServicePath;
        const url = new URL(apiUrl);
        url.searchParams.append('salesArticleNo', salesArticleNo);
        url.searchParams.append('masterArticleNo', masterArticleNo.toString());
        url.searchParams.append('colorCode', colorCode.toString());
        if (navigationKey) {
            url.searchParams.append('navigationkey', navigationKey);
        }

        return request<Array<string>>(url.toString())
            .then((avaialbeColorSAVKeys) => {
                if (!avaialbeColorSAVKeys)
                    throw new Error('fail to get colors: empty response');

                const results: Array<ISmakevailableVariant> = [];
                avaialbeColorSAVKeys.forEach((colorSAVKey) => {
                    results.push({
                        external_identifier: colorSAVKey
                    });
                });
                return results;
            })
            .catch(logHttpError);
    }

    public getArticleState(masterArticleNo: number, savKey: string): Promise<boolean> {
        const apiUrl = this.context.baseUrl
            + this.getLogoCreationStateForArticle;
        const url = new URL(apiUrl);
        url.searchParams.append('savKey', savKey);
        url.searchParams.append('masterArticleNo', masterArticleNo.toString());

        return request<boolean>(url.toString())
            .then((state) => state ?? false)
            .catch((error: unknown) => {
                logHttpError(error);
                return false;
            });
    }
}
